// Libraries.
import { combineReducers } from "redux";
import transactionReducer from "./Transaction/transaction.reducer";
import firebaseReducer from './Firebase/firebase.reducer';

const rootReducer = combineReducers({
  TransactionReducer: transactionReducer,
  FirebaseReducer: firebaseReducer
});

export default rootReducer;
